import { array, bool, object, ObjectSchema, string } from 'yup';
import messages from 'messages';
import { labelFormFieldConfig } from 'pages/app-pages/chatbot-builder-page/nodes/components/steps/form-components/utils';
import {
  OptionsMenuStepFormFields,
  OptionsMenuStepFormFieldsMenuNames,
  OptionsMenuStepFormFieldsNames,
} from 'pages/app-pages/chatbot-builder-page/nodes/components/steps/options-menu/types';
import { AutoCompleteLabel, FormFieldProps } from 'types';
import {
  editorValidation,
  emptyEditorValue,
  maxTelegramButtonLength,
  variableValidation,
} from 'utils';

export const OptionsMenuStepFormSchema: ObjectSchema<OptionsMenuStepFormFields> = object({
  [OptionsMenuStepFormFieldsNames.NodeId]: string().required('Node is required'),
  [OptionsMenuStepFormFieldsNames.Name]: string().required('Name is required'),
  [OptionsMenuStepFormFieldsNames.Input]: editorValidation,
  [OptionsMenuStepFormFieldsNames.Variable]: variableValidation,
  [OptionsMenuStepFormFieldsNames.Menu]: array(
    object({
      [OptionsMenuStepFormFieldsMenuNames.Option]: string()
        .max(
          maxTelegramButtonLength,
          `Option should be less than ${maxTelegramButtonLength} characters`,
        )
        .required('Option is required'),
      [OptionsMenuStepFormFieldsMenuNames.NodeId]: string().required('Node is required'),
      [OptionsMenuStepFormFieldsMenuNames.Name]: string().required('Name is required'),
    }),
  ).required(),
  [OptionsMenuStepFormFieldsNames.RemoveAnswerOptions]: bool(),
  [OptionsMenuStepFormFieldsNames.OptionFullWidth]: bool(),
  [OptionsMenuStepFormFieldsNames.HideOptions]: bool(),
  [OptionsMenuStepFormFieldsNames.ValidationMessage]: string().optional(),
  [OptionsMenuStepFormFieldsNames.BackButton]: bool(),
  [OptionsMenuStepFormFieldsNames.Labels]: array<AutoCompleteLabel[]>().optional(),
});

export const defaultOptionsMenuStepFormValues: OptionsMenuStepFormFields = {
  [OptionsMenuStepFormFieldsNames.NodeId]: '',
  [OptionsMenuStepFormFieldsNames.Name]: 'Multiple Choice',
  [OptionsMenuStepFormFieldsNames.Input]: emptyEditorValue,
  [OptionsMenuStepFormFieldsNames.Menu]: [],
  [OptionsMenuStepFormFieldsNames.RemoveAnswerOptions]: false,
  [OptionsMenuStepFormFieldsNames.OptionFullWidth]: false,
  [OptionsMenuStepFormFieldsNames.HideOptions]: false,
  [OptionsMenuStepFormFieldsNames.ValidationMessage]: '',
  [OptionsMenuStepFormFieldsNames.Labels]: [],
};

export const OptionsMenuFormFieldsConfig: Record<OptionsMenuStepFormFieldsNames, FormFieldProps> = {
  [OptionsMenuStepFormFieldsNames.Name]: {
    label: 'Name',
    placeholder: 'Name',
    name: OptionsMenuStepFormFieldsNames.Name,
    autoComplete: 'off',
    type: 'text',
  },
  [OptionsMenuStepFormFieldsNames.Input]: {
    placeholder: '* Ask a Question and Provide Options',
    name: OptionsMenuStepFormFieldsNames.Input,
    type: 'textarea',
  },
  [OptionsMenuStepFormFieldsNames.Variable]: {
    placeholder: 'Variable',
    name: OptionsMenuStepFormFieldsNames.Variable,
    autoComplete: 'off',
    type: 'text',
  },
  [OptionsMenuStepFormFieldsNames.Menu]: {
    label: 'Options',
    placeholder: 'Menu',
    name: OptionsMenuStepFormFieldsNames.Menu,
    autoComplete: 'off',
    type: 'text',
  },
  [OptionsMenuStepFormFieldsNames.NodeId]: {
    name: OptionsMenuStepFormFieldsNames.NodeId,
    type: 'hidden',
  },
  [OptionsMenuStepFormFieldsNames.RemoveAnswerOptions]: {
    label: messages.builder.removeAnswerOptions,
    name: OptionsMenuStepFormFieldsNames.RemoveAnswerOptions,
    type: 'checkbox',
  },
  [OptionsMenuStepFormFieldsNames.OptionFullWidth]: {
    label: messages.builder.optionFullWidth,
    name: OptionsMenuStepFormFieldsNames.OptionFullWidth,
    type: 'checkbox',
  },
  [OptionsMenuStepFormFieldsNames.HideOptions]: {
    label: messages.builder.hideOptions,
    name: OptionsMenuStepFormFieldsNames.HideOptions,
    type: 'checkbox',
  },
  [OptionsMenuStepFormFieldsNames.ValidationMessage]: {
    label: 'Custom Validation Message',
    placeholder: 'e.g. Please type one of the available options',
    name: OptionsMenuStepFormFieldsNames.ValidationMessage,
    autoComplete: 'off',
    type: 'text',
  },
  [OptionsMenuStepFormFieldsNames.BackButton]: {
    label: messages.builder.backButton,
    name: OptionsMenuStepFormFieldsNames.BackButton,
    type: 'checkbox',
  },
  [OptionsMenuStepFormFieldsNames.Labels]: labelFormFieldConfig,
};

export const OptionsMenuFormMenuFieldsConfig: Record<
  OptionsMenuStepFormFieldsMenuNames,
  FormFieldProps
> = {
  [OptionsMenuStepFormFieldsMenuNames.Name]: {
    label: 'Name',
    placeholder: 'Name',
    name: OptionsMenuStepFormFieldsMenuNames.Name,
    autoComplete: 'off',
    type: 'text',
  },

  [OptionsMenuStepFormFieldsMenuNames.Option]: {
    label: 'Option',
    name: OptionsMenuStepFormFieldsMenuNames.Option,
    autoComplete: 'off',
    type: 'text',
  },
  [OptionsMenuStepFormFieldsMenuNames.NodeId]: {
    name: OptionsMenuStepFormFieldsMenuNames.NodeId,
    type: 'hidden',
  },
};
